import React, { useContext } from "react";
import { Link as LocalLink } from "../../utils/Link";
import { LanguageContext, text } from "../../container/language";

export const Link = ({ route, text: title, icon }) => {
  const { userLanguage } = useContext(LanguageContext);

  return (
    <li className="quick-links__item">
      <LocalLink to={route}>
        <p>
          {/* <i className={icon}></i> */}
          <i className={`fa fa-${icon}`}></i>
        </p>
        <p>{text(title, userLanguage)}</p>
      </LocalLink>
    </li>
  );
};
